import Carousel, { CarouselTemplateSpec } from './Carousel';
import { ContentHubLaneItem } from 'services/cwData';
import BezelContentHubTile from '../tiles/BezelContentHubTile';

interface BezelButtonCarouselTemplate extends CarouselTemplateSpec {
  listType: typeof BezelContentHubTile;
  laneItem: ContentHubLaneItem;
}

export default class BezelButtonCarousel extends Carousel<BezelButtonCarouselTemplate> {
  override useHighlightFocus() {
    return false;
  }

  override getImageUrl() {
    return undefined;
  }

  $onTileHovered(target: BezelContentHubTile) {
    if (target !== this._List.currentItem) {
      this._List.currentItem._unfocus();
    }
  }

  override onGlobalHoverDisabled() {
    this._List.items.forEach((item: BezelContentHubTile) => {
      if (item.id !== this._List.currentItem.id) {
        item._unfocus?.();
      }
    });

    super.onGlobalHoverDisabled();
  }
}
